// @flow
import * as Immutable from "immutable";
import { handleActions, combineActions } from "redux-actions"
import * as Actions from "./securityActions"

const initialState: Immutable.Map<string, any> = Immutable.fromJS({
  accessToken: '',
  error: '',
  isFetchingData: true,
  role: '',
  userId: '',
  locationId: ''
});

const securityReducer = handleActions(
  {
    [combineActions(Actions.userLoginRequested, Actions.userLogoutRequested)](state) {
      return state
        .set('isFetchingData', true)
        .set('error', '')
    },
    [Actions.userLoginReceived](state, action) {
      return state
        .set('isFetchingData', false)
        .set('accessToken', action.payload.access_token)
        .set('userId', action.payload.userId)
        .set('role', action.payload.role)
        .set('locationId', action.payload.locationId || '')
    },
    [Actions.userLoginFailed](state, action) {
      return state
        .set('isFetchingData', false)
        .set('error', action.payload)
    },
    [Actions.userLogoutFailed](state, action) {
      return state
        .set('isFetchingData', false)
        .set('error', action.payload)
    },
    [Actions.userLogoutReceived](state, action) {
      return state
        .set('isFetchingData', false)
        .set('accessToken', '')
        .set('role', '')
        .set('locationId', '')
    },
  },
  initialState
)
export { securityReducer };



// WEBPACK FOOTER //
// ./src/security/securityReducer.js